'use client';

import { useIntersectionObserver } from '@/lib/hooks';
import { cn } from '@/lib/utils';
import { useTranslations } from 'next-intl';
import H6 from '../ui/H6';
import Section from './Section';

export default function AboutSection() {
    const t = useTranslations();
    const [ref, isObserved] = useIntersectionObserver({ threshold: 0.1 });

    return (
        <Section id="about" title={t('Header.about')} className="2xl:min-h-screen min-h-0">
            <div
                ref={ref}
                className={cn(
                    'max-xl:mx-5 xl:mr-28 gap-7 lg:gap-[100px] flex flex-col xl:w-4/6 2xl:w-3/4 xl:ml-auto transition-transform duration-1000 translate-y-20',
                    isObserved && 'translate-y-0',
                )}
            >
                <div className="max-w-[765px] flex flex-col gap-5 leading-none uppercase mt-20">
                    <h2 className="lg:text-h1 max-lg:text-h4 font-bold text-primary w-full">
                        {t('About.supporting')}
                    </h2>
                    <p className="lg:text-[45px] max-lg:text-h6">{t('About.dedicated')}</p>
                </div>
                <div className="flex flex-col gap-1 max-w-[350px] self-end">
                    <H6 className="lowercase font-normal max-lg:text-sm">{t('About.wePromote')}</H6>
                    {/* <Link className="w-fit" href="/">
                        <Button variant="primary" title={t('Buttons.learnMore')} />
                    </Link> */}
                </div>
            </div>
        </Section>
    );
}
